export default "//file.bilionpass.com/japandx-portal/0.1.17/static/img/feature-tax.1b50983e-077d6c.svg";